import React, { useMemo, useState } from 'react'

import { FilterActions, HomesFilters as HomesFiltersType, InitialFilterState, useFiltersContext } from '@/context'

import { ApplyButton, ClearButton, FilterOption } from './components'

type keys = keyof HomesFiltersType

type Props = {
  multiSelect?: boolean
  onClose: () => void
}
const HomesFilters = ({ onClose, multiSelect = false }: Props) => {
  const [{ homesFilters }, FilterDispatch] = useFiltersContext()
  const [filterOptions, setFilterOptions] = useState(homesFilters)

  const onSelectFilter = (selectedOption: { [key in keys]: boolean }) => {
    if (multiSelect) {
      setFilterOptions((prev) => ({ ...prev, ...selectedOption }))
    } else {
      setFilterOptions({ ...InitialFilterState['homesFilters'], ...selectedOption })
    }
  }

  const onApply = () => {
    FilterDispatch(FilterActions.setFilters({ filterName: 'homes', filters: filterOptions }))
    onClose()
  }

  const onClear = () => {
    FilterDispatch(FilterActions.clearFilters({ filterName: 'homes' }))

    onClose()
  }

  const showClearButton = useMemo(() => Object.keys(filterOptions).find((key) => !!filterOptions[key]), [filterOptions])

  return (
    <>
      <FilterOption label="Blocked" name="blocked" onSelect={onSelectFilter} value={filterOptions['blocked']} />
      <FilterOption label="Vacant" name="vacant" onSelect={onSelectFilter} value={filterOptions['vacant']} />
      <FilterOption label="New OD" name="newOD" onSelect={onSelectFilter} value={filterOptions['newOD']} />
      <FilterOption label="Occupied" name="occupied" onSelect={onSelectFilter} value={filterOptions['occupied']} />
      <FilterOption label="Leased" name="leased" onSelect={onSelectFilter} value={filterOptions['leased']} />
      <FilterOption label="Published" name="published" onSelect={onSelectFilter} value={filterOptions['published']} />
      <FilterOption label="Installed" name="installed" onSelect={onSelectFilter} value={filterOptions['installed']} />
      <FilterOption label="Autopilot" name="autopilot" onSelect={onSelectFilter} value={filterOptions['autopilot']} />
      <FilterOption label="Direct" name="direct" onSelect={onSelectFilter} value={filterOptions['direct']} />
      <FilterOption label="Standard" name="standard" onSelect={onSelectFilter} value={filterOptions['standard']} />
      <FilterOption
        label="Scheduled for Deinstall"
        name="scheduledForDeinstall"
        onSelect={onSelectFilter}
        value={filterOptions['scheduledForDeinstall']}
      />
      {showClearButton && <ClearButton onClick={onClear} />}
      <ApplyButton onClick={onApply} />
    </>
  )
}

export default HomesFilters
